import React, { useState, Fragment } from 'react';
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap';

import fobkLogo from '../assets/img/FoBK_Navbar.png'

import LoginModal from './auth/LoginModal'
import RegisterModal from './auth/RegisterModal'
import Logout from './auth/Logout'
import AdminNavItems from './AdminNavItems';

const NavBar = (props) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => setIsOpen(!isOpen);
    const userDetails = props.userDetails
    const isAdmin = userDetails && userDetails.user.permissionLevel || false

    return (
        <div>
            <Navbar color="light" light expand="md">
                <NavbarBrand href="/"><img src={fobkLogo} style={{ height: '30px' }} /></NavbarBrand>
                <NavbarToggler onClick={toggle} />
                <Collapse isOpen={isOpen} navbar>
                    {!props.hideNavbar && <Nav className="ml-auto" navbar>
                        {props.authenticated // TO display different Navbars for each state
                            ? <Fragment>
                                <AdminNavItems isAdmin={isAdmin} />
                                <NavItem>
                                    <NavLink href="/">My Profile</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink href="/eventregister">Event Registration</NavLink>
                                </NavItem>
                                <NavItem>
                                    <Logout setAuthenticated={props.setAuthenticated} />
                                </NavItem>
                            </Fragment>
                            : props.invalidToken && <Fragment>
                                <NavItem>
                                    <NavLink href="/eventregister">Events</NavLink>
                                </NavItem>
                                <NavItem>
                                    <RegisterModal setAuthenticated={props.setAuthenticated} />
                                </NavItem>
                                <NavItem>
                                    <LoginModal setAuthenticated={props.setAuthenticated} />
                                </NavItem>
                            </Fragment>
                        }

                    </Nav>}
                </Collapse>
            </Navbar>
        </div >
    );
}

export default NavBar;